import clsx from 'clsx';
import { type PhotosSelectorSize } from 'components/UI/V3/PhotosSelector/PhotosSelector';
import { FunctionComponent } from 'react';
import CoverTag from './CoverTag';
import DeleteButton from './DeleteButton';
import styles from './Photo.module.scss';

interface PhotoProps {
    src: string;
    isCover?: boolean;
    size?: PhotosSelectorSize;
    className?: string;
    onRemove?: () => void;
}

export const Photo: FunctionComponent<PhotoProps> = props => {
    return (
        <div
            className={clsx(styles.container, props.className, {
                [styles.small]: props.size === 'small'
            })}
        >
            <img
                src={props.src}
                className={styles.image}
            />
            {props.isCover && <CoverTag className={styles.cover} />}
            <DeleteButton
                className={styles.deleteButton}
                onClick={props.onRemove}
            />
        </div>
    );
};

export default Photo;
